<template>
  <SearchDropdown
    :placeholder="placeholder"
    :DisplayFunction="displayFunction"
    :InitialValue="initialValue || displayFunction(modalMessage)"
    :ObjKey="'id'"
    :width="width"
    :browseIcon="true"
    :pages="pages"
    :externalResults="items"
    :dropUp="dropUp"
    @selected="item => select(item)"
    @search="(txt, pg) => getList(txt, pg)"
    @none="select(null)"
    ref="search"
  />
</template>


<script>
import ModalMessageAPI from '@/api/ModalMessageAPI.js'
import PaginatedRequest from '@/api/PaginatedRequest.js'
import ModalMessage from './ModalMessage.js'
import SearchDropdown from '@/components/utilities/SearchDropdown.vue'

export default {
  name: 'ModalMessageSearchDropdown',

  components: {
    SearchDropdown,
  },


  props: {
    modalMessage: {
      type: Object,
      default: null
    },

    width: {
      type: String,
      default: '50%'
    },

    placeholder: {
      type: String,
      default: 'Search Modal Messages'
    },

    initialValue: {
      type: String,
      default: null
    },

		dropUp: {
			type: Boolean,
			default: false
		},

  },


  model: {
    prop: 'modalMessage',
    event: 'update'
  },

  data() {
    return {
      items: [],
      pages: 1,
    }
  },

  methods: {

    select(item) {
      this.$emit('update', item);
    },

    clear() { this.$refs.search.clear() },

    displayFunction(obj) {
      if(!obj) return '';
      return obj.name
    },

    async getList( searchTerm, page = 1 ) {
      const req = new PaginatedRequest()
      req.page = page
      req.pageSize = 25
      req.searchString = searchTerm || null
      const res = await ModalMessageAPI.getModalMessages( req )

      this.items = []
      if(!res) return
      this.pages = res.data.pages
      for(let item of res.data.data) this.items.push( ModalMessage.import( item ) )
    },
  }


}
</script>
